














































import { Vue, Component } from 'vue-property-decorator';
import BudtenderQuiz from '@/components/budtender/BudtenderQuiz.vue';
import BudtenderMedia from '@/components/budtender/BudtenderMedia.vue';
import BudtenderScorecard from '@/components/budtender/BudtenderScorecard.vue';
import { START_QUIZ } from '../../store/actions.type';
import { QUIZZES } from '../../common/brand.config';
import { Quiz } from '../../common/types';

@Component({
  components: {
    BudtenderQuiz,
    BudtenderMedia,
    BudtenderScorecard,
  },
})
export default class BudtenderHubPage extends Vue {
  currentQuestion = -1;

  quizTitle = 'Budtender Quiz';

  quiz: Quiz = QUIZZES.BRAND;

  answerSubmitted() {
    if (this.currentQuestion === -1) {
      this.$store.dispatch(START_QUIZ);
    }
    this.currentQuestion += 1;
  }
}
